import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";

export interface ConfirmationDialogRawProps {
    isOpen: boolean;
    headerLabel?: string;
    showDividers?: boolean;
    onClose(isConfirmed: boolean): void;
    onExited?(): void;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogRawProps> = ({
    headerLabel = "confirmationDialog.label.defaultHeader",
    showDividers = false,
    isOpen,
    onClose,
    onExited,
    children,
}) => {
    const { t } = useTranslation();
    const handleCancel = () => {
        onClose(false);
    };

    const handleOk = () => {
        onClose(true);
    };

    return (
        <Dialog disableEscapeKeyDown maxWidth="xs" onExited={onExited} open={isOpen}>
            <DialogTitle>{t(headerLabel)}</DialogTitle>
            <DialogContent dividers={showDividers}>{children}</DialogContent>
            <DialogActions>
                <Button disableRipple autoFocus onClick={handleCancel} color="primary">
                    {t("buttons.label.cancel")}
                </Button>
                <Button disableRipple onClick={handleOk} color="primary">
                    {t("buttons.label.ok")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
